var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SideFilter,{staticClass:"mt-0",attrs:{"filter-list":_setup.filtersProd},on:{"input":_setup.updateFilter,"clear":_setup.removeFilters}})
}
var staticRenderFns = []

export { render, staticRenderFns }